const costCenterServiceName = "/CostCenterSubCode";

export function costCenterSubCodeService (http) {
    return {
        getAllCostCenterSubCodesByCostCenter: (costCenterCode) => {
            const parameters = {
                params: {
                    costCenterCode
                }
            }
            return http.get(costCenterServiceName + "/GetAllCostCenterSubCodesAsync", parameters);
        },
        getCostCenterSubCode: (costCenterSubCodeParameter) => {
            let parameter = {
                costCenterCode: costCenterSubCodeParameter.costCenterCode,
                costCenterSubCode: costCenterSubCodeParameter.costCenterSubCode,
                persianDescription: costCenterSubCodeParameter.persianDescription,
                latinDescription: costCenterSubCodeParameter.latinDescription,
                costCenterDDM: costCenterSubCodeParameter.costCenterDDM
            };

            return http.post(
                costCenterServiceName + "/GetCostCenterSubCode",
                parameter
            );
        },
        addNewCostCenterSubCodesAsync: (costCenterSubCodeObject) => {
            let parameter = {
                costCenterCode: costCenterSubCodeObject.costCenterCode,
                costCenterSubCode: costCenterSubCodeObject.costCenterSubCode,
                persianDescription: costCenterSubCodeObject.persianDescription,
                latinDescription: costCenterSubCodeObject.latinDescription,
                costCenterDDM: costCenterSubCodeObject.costCenterDDM
            };

            return http.post(
                costCenterServiceName + "/AddNewCostCenterSubCodesAsync",
                parameter
            );
        },
        updateExistingCostCenterSubCodesAsync: (costCenterSubCodeObject) => {
            let parameter = {
                costCenterCode: costCenterSubCodeObject.costCenterCode,
                costCenterSubCode: costCenterSubCodeObject.costCenterSubCode,
                persianDescription: costCenterSubCodeObject.persianDescription,
                latinDescription: costCenterSubCodeObject.latinDescription,
                costCenterDDM: costCenterSubCodeObject.costCenterDDM
            };

            return http.post(
                costCenterServiceName + "/UpdateExistingCostCenterSubCodesAsync",
                parameter
            );
        } 
    }
}